<div data-test-id="admin-personas-upload-dialog">
  <h2 mat-dialog-title>Sample Document Upload</h2>
  <mat-dialog-content>
      Upload examples of documents reviewed by this person. After uploading, please allow a few minutes for us to generate the draft description.
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close data-test-id="admin-personas-upload-cancel-btn">Cancel</button>
    <button mat-button mat-dialog-close cdkFocusInitial [mat-dialog-close]="true" data-test-id="admin-personas-upload-upload-btn"><mat-icon>upload_file</mat-icon>Upload</button>
  </mat-dialog-actions>
</div>